var render = function () {
  var _vm$detail, _vm$detail$linkedAppl;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "desp"
  }, [_c('div', {
    staticClass: "desp-header"
  }, [_vm._v("Confirmation:")]), _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title-icon"
  }, [_c('svg-icon', {
    staticClass: "jump-icon",
    attrs: {
      "name": "applicant"
    }
  }), _vm._v(" Applicant information ")], 1), _c('div', {
    staticClass: "desp-items-wrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Applicant Name")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.detail.applicantName))])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Mobile")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.detail.applicantPhone))])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Email")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.detail.applicantEmail))])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Residential Address")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.detail.residentialAddress))])])]), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Applicant role")]), (_vm.detail.applymentStatus === 'REVISING' || _vm.detail.applymentStatus === 'CORRECTED' || _vm.detail.applymentStatus === 'ILLEGAL' || _vm.detail.applymentStatus === 'AUDIT_FAIL' || _vm.detail.applymentStatus === 'REFUND_APPLY_DENY' || _vm.detail.applymentStatus === 'REFUND_APPLY_REJECT' || _vm.detail.applymentStatus === 'ACRA_REJECTED') && _vm.isApplymentAuth('company:coordinate') ? [_c('el-select', {
    staticClass: "wd320",
    attrs: {
      "value": _vm.applicantRole,
      "placeholder": "Please Select"
    },
    on: {
      "change": _vm.applicantPositionChange
    }
  }, _vm._l(_vm.applicantPositionOptions, function (item) {
    return _c('el-option', {
      key: "applicantPosition".concat(item.value),
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)] : _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.applicantPositionFormat(_vm.detail.applicantPosition)))])], 2)])], 1)], 1)]), _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title-icon"
  }, [_c('svg-icon', {
    staticClass: "jump-icon",
    attrs: {
      "name": "country"
    }
  }), _vm._v(" Location of the proposed company/fund ")], 1), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-self"
  }, [_vm._v(_vm._s(_vm.detail.country))])])]), _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title-icon"
  }, [_c('svg-icon', {
    staticClass: "jump-icon",
    attrs: {
      "name": "planAndServices"
    }
  }), _vm._v(" Choice of service(s) ")], 1), _c('div', {
    staticClass: "desp-items-wrapper"
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Entity type")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.entityTypeFormat(_vm.detail.businessGenre)))])]), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Business type")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.businessTypeFormat(_vm.detail.businessType)))])]), _vm.detail.businessType == 'COMPREHENSIVE_CUSTOMIZED' || _vm.detail.businessType == 'FUND_ADMIN_CUSTOMIZED' ? [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Promotion code")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.detail.promotionCode))])])] : _vm._e()], 2), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-self"
  }, [_vm.detail.businessType == 'COMPANY_INCORPORATION' || _vm.detail.businessType == 'SERVICE_TRANSFER' ? _c('div', {
    staticClass: "mt10"
  }, [_vm.detail.goodsListType == 1 ? [_c('Package', {
    attrs: {
      "goodsList": _vm.detail.goodsList
    }
  })] : _vm._e(), _vm.detail.goodsListType == 2 ? [_c('diy-package', {
    attrs: {
      "businessType": _vm.detail.businessType,
      "goodsList": _vm.detail.goodsList
    }
  })] : _vm._e()], 2) : _vm._e(), _vm.detail.businessType == 'COMPREHENSIVE_CUSTOMIZED' || _vm.detail.businessType == 'FUND_ADMIN_CUSTOMIZED' ? _c('div', {
    staticClass: "mt10"
  }, [_c('quotation-list', {
    attrs: {
      "quotationList": _vm.detail.quotationList,
      "orderInfoList": _vm.detail.orderInfoList,
      "orderRefundList": _vm.detail.orderRefundList
    }
  })], 1) : _vm._e()])])]), _vm.detail.businessType == 'COMPANY_INCORPORATION' || _vm.detail.businessType == 'SERVICE_TRANSFER' ? _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Generic Invoice")]), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "flex desp-item-self"
  }, [_vm._l(_vm.detail.orderInfoList, function (item) {
    return _c('div', {
      key: "order-".concat(item.id)
    }, [item.customerInvoice.invoiceNumber ? _c('span', {
      staticClass: "mr30 to-link",
      on: {
        "click": function click($event) {
          return _vm.invoiceLink(item.customerInvoice.invoiceNumber);
        }
      }
    }, [_vm._v("Invoice")]) : _vm._e()]);
  }), _vm._l(_vm.detail.orderRefundList, function (item) {
    return _c('div', {
      key: "orderRefund-".concat(item.id)
    }, [item.customerInvoice.invoiceNumber ? _c('span', {
      staticClass: "mr30 to-link",
      on: {
        "click": function click($event) {
          return _vm.invoiceLink(item.customerInvoice.invoiceNumber);
        }
      }
    }, [_vm._v(" Credit Invoice ")]) : _vm._e()]);
  })], 2)])]) : _vm._e(), _vm.isAuth('company:coordinate') ? _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Front user website")]), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-self"
  }, [_c('span', {
    staticClass: "mr40 to-link",
    on: {
      "click": function click($event) {
        return _vm.userDetailLink('details');
      }
    }
  }, [_vm._v("View details")])])])]) : _vm._e(), _vm.isAuth('company:coordinate') && (_vm.detail.businessType == 'COMPREHENSIVE_CUSTOMIZED' || _vm.detail.businessType == 'FUND_ADMIN_CUSTOMIZED') ? _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Front user Fee Letter")]), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-self"
  }, [_c('span', {
    staticClass: "mr40 to-link",
    on: {
      "click": function click($event) {
        return _vm.userDetailLink('feeLetter', 'en');
      }
    }
  }, [_vm._v("View Fee Letter(EN)")]), _c('span', {
    staticClass: "to-link",
    on: {
      "click": function click($event) {
        return _vm.userDetailLink('feeLetter', 'zh');
      }
    }
  }, [_vm._v("View Fee Letter(CN)")])])])]) : _vm._e(), _vm.isAuth('company:coordinate') && (_vm.detail.businessType == 'COMPREHENSIVE_CUSTOMIZED' || _vm.detail.businessType == 'FUND_ADMIN_CUSTOMIZED') && _vm.detail.feeLetterUrls && _vm.detail.feeLetterUrls.length > 0 ? _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Service Quotation")]), _c('div', {
    staticClass: "pt10 desp-item"
  }, [_c('div', {
    staticClass: "desp-item-self"
  }, _vm._l(_vm.detail.feeLetterUrls, function (item) {
    return _c('p', {
      key: item.url,
      staticClass: "m0 lh22 pb10"
    }, [_c('a', {
      staticClass: "fs14 blue",
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.name))])]);
  }), 0)])]) : _vm._e(), _vm.isAuth('company:coordinate') && _vm.detail.hasRenew ? _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Linked Transaction No. (Renewal)")]), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-self"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.detail.linkedApplymentNo) + " " + _vm._s(_vm.applymentStatusFormat((_vm$detail = _vm.detail) === null || _vm$detail === void 0 ? void 0 : (_vm$detail$linkedAppl = _vm$detail.linkedApplyment) === null || _vm$detail$linkedAppl === void 0 ? void 0 : _vm$detail$linkedAppl.applymentStatus, true)) + " ")])])])]) : _vm._e(), _vm.isAuth('company:coordinate') && _vm.detail.hasLaterService ? _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Linked Transaction No. (Supplemental)")]), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-self"
  }, _vm._l(_vm.detail.laterServiceApplymentList, function (item) {
    return _c('span', {
      key: item.id,
      staticClass: "mr50"
    }, [_vm._v(" " + _vm._s(item.applymentNo) + " " + _vm._s(_vm.applymentStatusFormat(item.applymentStatus, true)) + " ")]);
  }), 0)])]) : _vm._e(), _vm.isAuth('company:coordinate') && _vm.detail.excApplymentNo ? _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v(" Linked Transaction No. "), _vm.detail.isRenew ? _c('span', [_vm._v("(Be Renewed)")]) : _vm._e(), _vm.detail.isLaterService ? _c('span', [_vm._v("(Have Supplements)")]) : _vm._e()]), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-self"
  }, [_c('span', [_vm._v(_vm._s(_vm.detail.excApplymentNo))])])])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }